const commons = require("./gatsby-config/common");

exports.wrapPageElement = commons.wrapPageElement;

exports.wrapRootElement = commons.wrapRootElement;
